define([
  "jquery",
  "underscore",
  "marionette",
  "views/common/search_input_view"
], function ($, _, Marionette, SearchInput) {
  new SearchInput();
  return Marionette.View.extend({
    el: '#content_layout',

    ui: {
      'trigger': '.dropdown-container .trigger',
      'content': '.dropdown-container .content',
      'toc': '.toc-container',
      'tocTitle': '.toc-container .toc-title',
      'tocWrapper': '.toc-container .toc-wrapper',
      'tocLinks': '.toc-wrapper a'
    },

    events: {
      'click @ui.trigger': 'toggleDropdown',
      'click @ui.tocTitle': 'toggleToc',
      'click @ui.tocLinks': 'saveScrollPosition' // 클릭 시 스크롤 저장
    },

    initialize: function () {
      this.bindUIElements();
      this.restoreScrollPosition();
    },

    toggleDropdown: function () {
      $(this.ui.trigger).toggleClass('enable');
      $(this.ui.content).toggleClass('hidden');
    },

    toggleToc: function (event) {
      const parentNode = $(event.target).parent();

      if (!$(parentNode).hasClass('collapse')) {
        $(parentNode).addClass('collapse');
        return;
      }

      $(this.ui.toc).addClass('collapse');
      $(parentNode).removeClass('collapse');
    },

    saveScrollPosition: function () {
      const tocWrapper = this.ui.tocWrapper[0];
      localStorage.setItem("tocScroll", tocWrapper.scrollTop);
    },

    restoreScrollPosition: function () {
      const tocWrapper = this.ui.tocWrapper[0];
      const savedScroll = localStorage.getItem("tocScroll");

      if (savedScroll !== null) {
        tocWrapper.scrollTop = parseInt(savedScroll, 10);
      }
    }
  })
})